<template lang="pug">
	button.btn.waves-effect(
		@click='onClick'
		:disabled='params.disabled'
		:class='params.class'
	)
		template(
			v-if='image'
		)
			icon(
				:icon-name='image'
			)
		| {{ params.label }}
</template>

<script>
import icon from '__jsVueUI/icon.vue';

export default {
	name:  'btn',

	props: ['params', 'image'],

	components: {
		icon
	},

	methods: {
		onClick() {
			this.$emit('click');
		}
	},
};
</script>
